// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueDND from 'awe-dnd'
import ViewUI from 'view-design'
import VeLine from 'v-charts/lib/line.common'
import VePie from 'v-charts/lib/pie.common'
import VeBar from 'v-charts/lib/bar.common'
import 'view-design/dist/styles/iview.css'
import Axios from 'axios'
import AOS from 'aos'
import '../node_modules/aos/dist/aos.css'
import VueClipboard from 'vue-clipboard2'

Vue.prototype.$axios = Axios

Vue.use(ViewUI)
Vue.use(VueDND)
Vue.use(VueClipboard)
Vue.use(AOS)

Vue.config.productionTip = false
Vue.component(VeLine.name, VeLine)
Vue.component(VePie.name, VePie)
Vue.component(VeBar.name, VeBar)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js